module.exports = __webpack_public_path__ + "static/media/DesignSmartSlide04.fe91ea67.jpg";